import { render, staticRenderFns } from "./SelectApprovalStatus.vue?vue&type=template&id=10dabb61"
import script from "./SelectApprovalStatus.vue?vue&type=script&lang=js"
export * from "./SelectApprovalStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports